/**
 * 主题根组件：按 theme store 的实际主题选择 antd 算法和 token。
 * antd 的 --ant-* CSS 变量挂在带 css-var-* 类的元素上，ConfigProvider 本身不渲染 DOM，
 * 所以用 antd <App> 作为全部页面内容的最外层：它带上这个类、铺满视口并铺 colorBgLayout 背景。
 */
import type { ReactNode } from 'react'
import { ConfigProvider, App as AntdApp } from 'antd'
import zhCN from 'antd/locale/zh_CN'
import { useAppliedTheme } from '@/stores/theme'
import { FeedbackBinder } from '@/lib/feedback'
import { getThemeConfig } from './tokens'
import styles from './ThemeProvider.module.css'

export function ThemeProvider({ children }: Readonly<{ children: ReactNode }>) {
  const appliedTheme = useAppliedTheme()

  return (
    <ConfigProvider locale={zhCN} theme={getThemeConfig(appliedTheme)}>
      <AntdApp className={styles.root}>
        <FeedbackBinder />
        {children}
      </AntdApp>
    </ConfigProvider>
  )
}
